module.exports = __webpack_public_path__ + "static/parc-7617ec45b8793b41bac367a4d8ebd4ca.jpg";